import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ──────────────────────────────────────────────────────────────────
// Service Worker 登録（静的アセットのキャッシュ管理のみ）
// バージョン確認は useVersionCheck（Firestoreベース）に一本化
// localhost では登録しない（devサーバーはハッシュなしファイル名のため古いキャッシュが返る）
// ──────────────────────────────────────────────────────────────────
const registerServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) return;
  // localhost / 127.0.0.1 では登録しない
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    // 既存の SW がいれば解除する
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const reg of registrations) {
      await reg.unregister();
      console.debug('[SW-Register] localhost: Service Worker を解除しました');
    }
    return;
  }
  try {
    await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
    console.debug('[SW-Register] Service Worker 登録完了');
  } catch (err) {
    console.error('[SW-Register] Service Worker 登録失敗:', err);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', registerServiceWorker);
} else {
  registerServiceWorker();
}
